// Cartes superposées au HES (modèle v2) : projects/{projectId}/samples/{sampleId}/overlays/{overlayId}. Pour l'instant
// des cartes par patchs (kind 'attention') : patchs du CSV importé (points : x, y, valeur en Float32, base64 ; value :
// nom de la colonne, attention, contribution…), taille des patchs, transformation affine vers la grille commune (calage
// sur le HES) ; docs/DATA_MODEL.md.
import {
  addDoc, collection, deleteDoc, doc, onSnapshot, orderBy, query, serverTimestamp, updateDoc,
} from 'firebase/firestore';
import { db } from './firebase';
import { docData } from './projects';

const overlaysOf = (projectId, sampleId) => collection(db(), 'projects', projectId, 'samples', sampleId, 'overlays');

export function watchOverlays(projectId, sampleId, onChange, onError) {
  return onSnapshot(query(overlaysOf(projectId, sampleId), orderBy('createdAt')),
    snap => onChange(snap.docs.map(docData)), onError);
}

// Nouvelle carte d'attention ; renvoie son id.
export async function addAttentionMap(profile, projectId, sampleId, {
  name, value, points, count, patchSize, transform, placement,
}) {
  const ref = await addDoc(overlaysOf(projectId, sampleId), {
    kind: 'attention', name, value, points, count, patchSize, transform, placement,
    createdBy: profile.uid, createdAt: serverTimestamp(),
  });
  return ref.id;
}

// Nouveau calage (transformation et sa méthode).
export const setOverlayPlacement = (projectId, sampleId, overlayId, transform, placement) =>
  updateDoc(doc(overlaysOf(projectId, sampleId), overlayId), { transform, placement });

export const deleteOverlay = (projectId, sampleId, overlayId) => deleteDoc(doc(overlaysOf(projectId, sampleId), overlayId));
